export enum TenantIconNameEnum {
  upTrendArrow = "upTrendArrow",
  downTrendArrow = "downTrendArrow",
  airConditioning = "airConditioning",
  airplaneArrival = "airplaneArrival",
  airplaneDeparture = "airplaneDeparture",
  bedFilled = "bedFilled",
  bell = "bell",
  cash = "cash",
  cashBag = "cashBag",
  chevronRightLight = "chevronRightLight",
  clear = "clear",
  clock = "clock",
  coin = "coin",
  customerSupport = "customerSupport",
  cvv = "cvv",
  drawer = "drawer",
  faq = "faq",
  help = "help",
  house = "house",
  infoFilled = "infoFilled",
  luggage = "luggage",
  location = "location",
  phone = "phone",
  predictionDanger = "predictionDanger",
  predictionNormal = "predictionNormal",
  predictionWarning = "predictionWarning",
  priceBreakdown = "priceBreakdown",
  pricePrediction = "pricePrediction",
  refund = "refund",
  sort = "sort",
  send = "send",
  star = "star",
  trips = "trips",
  user = "user",
  wallet = "wallet",
  watchedTrips = "watchedTrips",
}
